import {
  BarChart as BarChartPrimitive,
  Bar,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
} from 'recharts';
import { Text, textVariantClasses } from '@/components/ui/Text';
import clsx from 'clsx';

interface BarChartProps {
  data: { label: string; value: number }[];
  unit?: string;
}

export function BarChart({ data, unit = 'h' }: BarChartProps) {
  return (
    <ResponsiveContainer width="100%" height={300} className="mt-md">
      <BarChartPrimitive data={data} margin={{ left: 40, right: 40, bottom: 10, top: 10 }}>
        <Bar dataKey="value" fill="#2FD181" radius={[4, 4, 0, 0]} />
        <XAxis
          dataKey="label"
          stroke="#8897AE"
          tickMargin={8}
          tick={({ x, y, payload }) => {
            return (
              <g transform={`translate(${x},${y})`}>
                <text
                  x={0}
                  y={0}
                  textAnchor="middle"
                  className={clsx(textVariantClasses['label-2xs-strong'], 'fill-neutral-default')}
                >
                  <tspan x={0} dy={10}>
                    {payload.value}
                  </tspan>
                </text>
              </g>
            );
          }}
        />
        <YAxis
          width="auto"
          stroke="#8897AE"
          tickMargin={8}
          tick={({ x, y, payload }) => {
            return (
              <g transform={`translate(${x},${y})`}>
                <text
                  x={0}
                  y={0}
                  dy={2.5}
                  textAnchor="end"
                  className={clsx(textVariantClasses['label-2xs-strong'], 'fill-neutral-default')}
                >
                  {payload.value}
                  {unit}
                </text>
              </g>
            );
          }}
        />
        <Tooltip
          content={({ active, payload, label }) => {
            if (active && payload && payload.length) {
              return (
                <div className="bg-base-white border-transparent-dark-12 p-xs rounded-md border shadow-xs">
                  <Text variant="label" size="xs" className="text-neutral-muted mb-4xs">
                    {label}
                  </Text>
                  <Text variant="label" size="xs" strong>
                    {payload[0].value}
                    {unit}
                  </Text>
                </div>
              );
            }
            return null;
          }}
        />
      </BarChartPrimitive>
    </ResponsiveContainer>
  );
}
